import { Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { TextTypeEnum } from '@authority-labs/enums';
import { NotesBankDialogComponent } from './notes-bank-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class NotesBankDialogService {
  private dialogConfig: MatDialogConfig;

  constructor(private dialog: MatDialog) {
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.minWidth = '65vw';
  }

  show(
    type: TextTypeEnum | string,
    supportDefault: boolean = false
  ): MatDialogRef<NotesBankDialogComponent, Partial<string>> {
    this.dialogConfig.data = { type, multi: false, supportDefault };
    return this.dialog.open<NotesBankDialogComponent, Partial<string>>(
      NotesBankDialogComponent,
      this.dialogConfig
    );
  }

  showMulti(
    type: TextTypeEnum | string
  ): MatDialogRef<NotesBankDialogComponent, string | string[]> {
    this.dialogConfig.data = { type, multi: true };
    return this.dialog.open<NotesBankDialogComponent, string | string[]>(
      NotesBankDialogComponent,
      this.dialogConfig
    );
  }
}
